<template lang="pug">
.page 
    a-tabs(tab-position="right")
        a-tab-pane(tab="AUM" key="AUM")
            AUMEdit
        a-tab-pane(tab="Weight" key="Weight")
            WeightEdit
</template>

<script> 
import WeightEdit from './WeightEdit.vue';
import AUMEdit from './AUMEdit.vue';

export default {
  data() {
    return {
      
    }
  },
  methods: {
    
  },
  mounted() {
    
  },
  components: {
    WeightEdit,
    AUMEdit
  },
}
</script>